@if (icon) {
    <ion-icon [name]="icon" aria-hidden="true" />
} @else if (image) {
    <img [src]="image" role="presentation" alt="">
}
@if (message) {
    <p>{{ message }}</p>
}
<ng-content />
